import { render, staticRenderFns } from "./SLabel.vue?vue&type=template&id=2cea52be&lang=pug"
import script from "./SLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SLabel.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports